<template>
  <div class="small">Selecciona el primer y segundo equipo de cada grupo.</div>
  <br>
  <div class="groupDesktop">
    <div class="row">
        <teams-list group="Grupo A" :groupList="groupA" @pos1="Clearfirsts($event), ChangeA1($event)" @pos2="Clearfirsts($event), ChangeA2($event)"></teams-list>
        <teams-list group="Grupo B" :groupList="groupB" @pos1="Clearfirsts($event), ChangeB1($event)" @pos2="Clearfirsts($event), ChangeB2($event)"></teams-list>
        <teams-list group="Grupo C" :groupList="groupC" @pos1="Clearfirsts($event), ChangeC1($event)" @pos2="Clearfirsts($event), ChangeC2($event)"></teams-list>
        <teams-list group="Grupo D" :groupList="groupD" @pos1="Clearfirsts($event), ChangeD1($event)" @pos2="Clearfirsts($event), ChangeD2($event)"></teams-list>
    </div>
    <div class="row">
        <teams-list group="Grupo E" :groupList="groupE" @pos1="ChangeE1($event), Clearfirsts($event)" @pos2="ChangeE2($event), Clearfirsts($event)"></teams-list>
        <teams-list group="Grupo F" :groupList="groupF" @pos1="ChangeF1($event), Clearfirsts($event)" @pos2="ChangeF2($event), Clearfirsts($event)"></teams-list>
        <teams-list group="Grupo G" :groupList="groupG" @pos1="ChangeG1($event), Clearfirsts($event)" @pos2="ChangeG2($event), Clearfirsts($event)"></teams-list>
        <teams-list group="Grupo H" :groupList="groupH" @pos1="ChangeH1($event), Clearfirsts($event)" @pos2="ChangeH2($event), Clearfirsts($event)"></teams-list>
    </div>
  </div>
  <div class="groupMobile">
    <div id="myCarousel" class="carousel slide" data-ride="carousel" data-interval="8000">
      <ol class="carousel-indicators">
    <li data-target="#myCarousel" data-slide-to="0" class="active">A</li>
    <li data-target="#myCarousel" data-slide-to="1">B</li>
    <li data-target="#myCarousel" data-slide-to="2">C</li>
    <li data-target="#myCarousel" data-slide-to="3">D</li>
    <li data-target="#myCarousel" data-slide-to="4">E</li>
    <li data-target="#myCarousel" data-slide-to="5">F</li>
    <li data-target="#myCarousel" data-slide-to="6">G</li>
    <li data-target="#myCarousel" data-slide-to="7">H</li>
  </ol>
  <div class="carousel-inner" role="listbox">
    <div class="item active">
      <teams-list group="Grupo A" :groupList="groupA" @pos1="Clearfirsts($event), ChangeA1($event)" @pos2="Clearfirsts($event), ChangeA2($event)"></teams-list>
    </div>
    <div class="item">
      <teams-list group="Grupo B" :groupList="groupB" @pos1="Clearfirsts($event), ChangeB1($event)" @pos2="Clearfirsts($event), ChangeB2($event)"></teams-list>      
    </div>
    <div class="item">
      <teams-list group="Grupo C" :groupList="groupC" @pos1="Clearfirsts($event), ChangeC1($event)" @pos2="Clearfirsts($event), ChangeC2($event)"></teams-list>  
    </div>
    <div class="item">
      <teams-list group="Grupo D" :groupList="groupD" @pos1="Clearfirsts($event), ChangeD1($event)" @pos2="Clearfirsts($event), ChangeD2($event)"></teams-list>
      </div>
    <div class="item">
      <teams-list group="Grupo E" :groupList="groupE" @pos1="ChangeE1($event), Clearfirsts($event)" @pos2="ChangeE2($event), Clearfirsts($event)"></teams-list>
        </div>
    <div class="item">
      <teams-list group="Grupo F" :groupList="groupF" @pos1="ChangeF1($event), Clearfirsts($event)" @pos2="ChangeF2($event), Clearfirsts($event)"></teams-list>
        </div>
    <div class="item">
      <teams-list group="Grupo G" :groupList="groupG" @pos1="ChangeG1($event), Clearfirsts($event)" @pos2="ChangeG2($event), Clearfirsts($event)"></teams-list>
        </div>
    <div class="item">
      <teams-list group="Grupo H" :groupList="groupH" @pos1="ChangeH1($event), Clearfirsts($event)" @pos2="ChangeH2($event), Clearfirsts($event)"></teams-list>
    </div>
    <a class="left carousel-control" href="#myCarousel" role="button" data-slide="prev">
        <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="right carousel-control" href="#myCarousel" role="button" data-slide="next">
        <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
  </div>
</div>
  </div>
    <br>
    <div class="small">Ahora haz clic en los ganadores de cada partido para crear tu simulador.</div>
    <div class="row" id="printArea">
      <div class="col align-self-center">
        <div class="col rightDown">
          <div class="selected1 emptyTeam disable first nameLeft select01 winner1" v-bind:id="'team'+placeA1" @click="selectQuarter1(placeA1), selectLine(1, placeA1), selectFirsts(placeA1, 1, 9, 13, 15)"></div>
        </div>
        <div class="col rightUp">
          <div class="selected2 emptyTeam disable first nameLeft winner1" v-bind:id="'team'+placeB2" @click="selectQuarter1(placeB2), selectLine(1, placeB2), selectFirsts(placeB2, 1, 9, 13, 15)"></div>
        </div>
        <div class="col rightDown">
        <div class="selected3 emptyTeam disable first nameLeft winner2" v-bind:id="'team'+placeC1" @click="selectQuarter2(placeC1), selectLine(2, placeC1), selectFirsts(placeC1, 2, 9, 13, 15)"></div>
      </div><div class="col rightUp">
        <div class="selected4 emptyTeam disable first nameLeft winner2" v-bind:id="'team'+placeD2" @click="selectQuarter2(placeD2), selectLine(2, placeD2), selectFirsts(placeD2, 2, 9, 13, 15)"></div>
      </div><div class="col rightDown">
        <div class="selected5 emptyTeam disable first nameLeft winner3" v-bind:id="'team'+placeE1" @click="selectQuarter3(placeE1), selectLine(3, placeE1), selectFirsts(placeE1, 3, 10, 13, 15)"></div>
      </div><div class="col rightUp">
        <div class="selected6 emptyTeam disable first nameLeft winner3" v-bind:id="'team'+placeF2" @click="selectQuarter3(placeF2), selectLine(3, placeF2), selectFirsts(placeF2, 3, 10, 13, 15)"></div>
      </div>
        <div class="col rightDown">
        <div class="selected7 emptyTeam disable first nameLeft winner4" v-bind:id="'team'+placeG1" @click="selectQuarter4(placeG1), selectLine(4, placeG1), selectFirsts(placeG1, 4, 10, 13, 15)"></div>
      </div>
        <div class="col rightUp">
        <div class="selected8 emptyTeam disable first nameLeft winner4" v-bind:id="'team'+placeH2" @click="selectQuarter4(placeH2), selectLine(4, placeH2), selectFirsts(placeH2, 4, 10, 13, 15)"></div>
      </div>
      </div>
      <div class="col align-self-center">    
        <div class="col rightDownQuarter">
        <div class="selected17 emptyTeam disable finals quarter nameLeft select1 winner9" v-bind:id="'team'+quarter1" @click="selectSemi1(quarter1), selectLine(9, quarter1), selectSeconds(quarter1, 9, 13, 15)"></div>
      </div>
        <div class="col rightUpQuarter">
        <div class="selected18 emptyTeam disable finals quarter nameLeft select2 winner9" v-bind:id="'team'+quarter2" @click="selectSemi1(quarter2), selectLine(9, quarter2), selectSeconds(quarter2, 9, 13, 15)"></div>
      </div>
        <div class="col rightDownQuarter">
        <div class="selected19 emptyTeam disable finals quarter nameLeft select3 winner10" v-bind:id="'team'+quarter3" @click="selectSemi2(quarter3), selectLine(10, quarter3), selectSeconds(quarter3, 10, 13, 15)"></div>
      </div>
        <div class="col rightUpQuarter">
        <div class="selected20 emptyTeam disable finals quarter nameLeft select4 winner10" v-bind:id="'team'+quarter4" @click="selectSemi2(quarter4), selectLine(10, quarter4), selectSeconds(quarter4, 10, 13, 15)"></div>
      </div>
      </div>
      <div class="col align-self-center">
        <div class="col rightDownSemi">
        <div class="selected25 emptyTeam disable finals quarter semi nameLeft select9 winner13" v-bind:id="'team'+semi1" @click="selectFinal1(semi1), selectLine(13, semi1), selectThirds(semi1, 13, 15)"></div>
      </div>
        <div class="col rightUpSemi">
        <div class="selected26 emptyTeam disable finals quarter semi nameLeft select10 winner13" v-bind:id="'team'+semi2" @click="selectFinal1(semi2), selectLine(13, semi2), selectThirds(semi2, 13, 15)"></div>
      </div>
      </div>
      <div class="col align-self-center">
        <div class="col centerFinal"><div class="selected29 emptyTeam disable finals quarter semi final nameLeft select13 winner15" v-bind:id="'team'+final1" @click="selectWinner(final1), selectLine(15, final1), selectFourths(final1, 15)"></div>
      </div>
      </div>
      <div class="col align-self-center">
        <div class="col">
        <div class="selected31 emptyTeam disable finals quarter semi final champion select15" v-bind:id="'team'+winner" >{{winner}}</div>
        </div>
    </div>
      <div class="col align-self-center">
        <div class="col centerFinal">
        <div class="selected30 emptyTeam disable finals quarter semi final nameRight select14 winner15" v-bind:id="'team'+final2" @click="selectWinner(final2), selectLine(15, final2), selectFourths(final2, 15)"></div>
      </div>
      </div>
      <div class="col align-self-center">
        <div class="col leftDownSemi">
        <div class="selected27 emptyTeam disable finals quarter semi nameRight select11 winner14" v-bind:id="'team'+semi3" @click="selectFinal2(semi3), selectLine(14, semi3), selectThirds(semi3, 14, 15)"></div>
        </div>
        <div class="col leftUpSemi">
        <div class="selected28 emptyTeam disable finals quarter semi nameRight select12 winner14" v-bind:id="'team'+semi4" @click="selectFinal2(semi4), selectLine(14, semi4), selectThirds(semi4, 14, 15)"></div>
        </div>
      </div>
      <div class="col align-self-center">
        <div class="col leftDownQuarter">
        <div class="selected21 emptyTeam disable finals quarter nameRight select5 winner11" v-bind:id="'team'+quarter5" @click="selectSemi3(quarter5), selectLine(11, quarter5), selectSeconds(quarter5, 11, 14, 15)"></div>
        </div>
        <div class="col leftUpQuarter">
        <div class="selected22 emptyTeam disable finals quarter nameRight select6 winner11" v-bind:id="'team'+quarter6" @click="selectSemi3(quarter6), selectLine(11, quarter6), selectSeconds(quarter6, 11, 14, 15)"></div>
        </div>
        <div class="col leftDownQuarter">
        <div class="selected23 emptyTeam disable finals quarter nameRight select7 winner12" v-bind:id="'team'+quarter7" @click="selectSemi4(quarter7), selectLine(12, quarter7), selectSeconds(quarter7, 12, 14, 15)"></div>
        </div>
        <div class="col leftUpQuarter">
        <div class="selected24 emptyTeam disable finals quarter nameRight select8 winner12" v-bind:id="'team'+quarter8"  @click="selectSemi4(quarter8), selectLine(12, quarter8), selectSeconds(quarter8, 12, 14, 15)"></div>
        </div>
      </div>
      <div class="col align-self-center">
        <div class="col leftDown">
        <div class="selected9 emptyTeam disable first nameRight winner5" v-bind:id="'team'+placeB1" @click="selectQuarter5(placeB1), selectLine(5, placeB1), selectFirsts(placeB1, 5, 11, 14, 15)"></div>
      </div>
        <div class="col leftUp">
        <div class="selected10 emptyTeam disable first nameRight select02 winner5" v-bind:id="'team'+placeA2" @click="selectQuarter5(placeA2), selectLine(5, placeA2), selectFirsts(placeA2, 5, 11, 14, 15)"></div>
      </div>
        <div class="col leftDown">
        <div class="selected11 emptyTeam disable first nameRight winner6" v-bind:id="'team'+placeD1" @click="selectQuarter6(placeD1), selectLine(6, placeD1), selectFirsts(placeD1, 6, 11, 14, 15)"></div>
      </div>
        <div class="col leftUp">
        <div class="selected12 emptyTeam disable first nameRight winner6" v-bind:id="'team'+placeC2" @click="selectQuarter6(placeC2), selectLine(6, placeC2), selectFirsts(placeC2, 6, 11, 14, 15)"></div>
      </div>
        <div class="col leftDown">
        <div class="selected13 emptyTeam disable first nameRight winner7" v-bind:id="'team'+placeF1" @click="selectQuarter7(placeF1), selectLine(7, placeF1), selectFirsts(placeF1, 7, 12, 14, 15)"></div>
      </div>
        <div class="col leftUp">
        <div class="selected14 emptyTeam disable first nameRight winner7" v-bind:id="'team'+placeE2" @click="selectQuarter7(placeE2), selectLine(7, placeE2), selectFirsts(placeE2, 7, 12, 14, 15)"></div>
      </div>
        <div class="col leftDown">
        <div class="selected15 emptyTeam disable first nameRight winner8" v-bind:id="'team'+placeH1" @click="selectQuarter8(placeH1), selectLine(8, placeH1), selectFirsts(placeH1, 8, 12, 14, 15)"></div>
      </div>
        <div class="col leftUp">
        <div class="selected16 emptyTeam disable first nameRight winner8" v-bind:id="'team'+placeG2" @click="selectQuarter8(placeG2), selectLine(8, placeG2), selectFirsts(placeG2, 8, 12, 14, 15)"></div>
      </div>
      </div>
      <strong class="small">bwin.co | Todos los derechos reservados - Síguenos en las redes sociales</strong>
    </div>
    
    
    <div class="checkTac"><label for="tac" class="container small"><input type="checkbox" id="tac" name="tac" value="ok" disabled v-on:change="checkTac($event)">
    <span class="checkmark" id="checkmark"></span> He leído y acepto los <a href="https://help.bwin.co/es/general-information/security/cookies-notice" class="tacLink" target="_blank">términos y condiciones</a> de la promoción</label></div><br>
    <ShareNetwork id="btnShare" class="btnShare" network="twitter" 
    url="https://blog.bwin.co/simulador-mundial-2022/" 
    v-bind:title="title"
    hashtags="bwinMundial2022"> COMPARTIR </ShareNetwork>
    <ShareNetwork id="btnShareMobile" class="btnShare" network="twitter" 
    url="https://blog.bwin.co/simulador-mundial-2022/" 
    v-bind:title="title"
    hashtags="bwinMundial2022" @click="printMobile()"> COMPARTIR </ShareNetwork>
    <button class="btnPrint" id="btnPrint" @click="changeTwitter(), printThis()">COMPARTIR</button>
    <button class="btnClear" id="btnClear" @click="ClearAll()" >REINICIAR</button>
    
</template>

<script>
import TeamsList from './TeamsList.vue'
import * as htmlToImage from 'html-to-image'
import download from 'downloadjs'
//import VueSocialSharing from 'vue-social-sharing'

export default {
  components: { TeamsList },
    name: "GroupsList",
    data() {
    return {
      title:'Simulador Mundial 2022',
      placeA1:'',
      placeA2:'',
      placeB1:'',
      placeB2:'',
      placeC1:'',
      placeC2:'',
      placeD1:'',
      placeD2:'',
      placeE1:'',
      placeE2:'',
      placeF1:'',
      placeF2:'',
      placeG1:'',
      placeG2:'',
      placeH1:'',
      placeH2:'',
      quarter1:'',
      quarter2:'',
      quarter3:'',
      quarter4:'',
      quarter5:'',
      quarter6:'',
      quarter7:'',
      quarter8:'',
      semi1:'',
      semi2:'',
      semi3:'',
      semi4:'',
      final1:'',
      final2:'',
      winner:'',
      groupA: [
        { id: 1, name: "Qatar", short: "QAT", flag: "Catar" },
        { id: 2, name: "Ecuador", short: "ECU", flag: "Equador" },
        { id: 3, name: "Países Bajos", short: "HOL", flag: "Holanda" },
        { id: 4, name: "Senegal", short: "SEN", flag: "Senegal" }
      ],
      groupB: [
        { id: 5, name: "USA", short: "USA", flag: "Estados_Unidos" },
        { id: 6, name: "Inglaterra", short: "ING", flag: "Inglaterra" },
        { id: 7, name: "Irán", short: "IRA", flag: "Ira" },
        { id: 8, name: "Gales", short: "GAL", flag: "Pais_de_Gales" }
      ],
      groupC: [
        { id: 9, name: "Arabia Saudí", short: "ARA", flag: "Arabia_Saudita" },
        { id: 10, name: "Argentina", short: "ARG", flag: "Argentina" },
        { id: 11, name: "México", short: "MEX", flag: "Mexico" },
        { id: 12, name: "Polonia", short: "POL", flag: "Polonia" }
      ],
      groupD: [
        { id: 13, name: "Dinamarca", short: "DIN", flag: "Dinamarca" },
        { id: 14, name: "Australia", short: "AUS", flag: "Australia" },
        { id: 15, name: "Francia", short: "FRA", flag: "Franca" },
        { id: 16, name: "Túnez", short: "TUN", flag: "Tunisia" }
      ],
      groupE: [
        { id: 17, name: "Alemania", short: "ALE", flag: "Alemanha" },
        { id: 18, name: "Costa Rica", short: "COS", flag: "Costa_Rica" },
        { id: 19, name: "España", short: "ESP", flag: "Espanha" },
        { id: 20, name: "Japón", short: "JAP", flag: "Japao" }
      ],
      groupF: [
        { id: 21, name: "Bélgica", short: "BEL", flag: "Belgica" },
        { id: 22, name: "Canadá", short: "CAN", flag: "Canada" },
        { id: 23, name: "Croacia", short: "CRO", flag: "Croacia" },
        { id: 24, name: "Marruecos", short: "MAR", flag: "Marrocos" }
      ],
      groupG: [
        { id: 25, name: "Brasil", short: "BRA", flag: "Brasil" },
        { id: 26, name: "Camerún", short: "CAM", flag: "Camaroes" },
        { id: 27, name: "Serbia", short: "SER", flag: "Servia" },
        { id: 28, name: "Suiza", short: "SUI", flag: "Suica" }
      ],
      groupH: [
        { id: 29, name: "Corea del Sur", short: "COR", flag: "Coreia_do_Sul" },
        { id: 30, name: "Ghana", short: "GAN", flag: "Gana" },
        { id: 31, name: "Portugal", short: "POR", flag: "Portugal" },
        { id: 32, name: "Uruguay", short: "URU", flag: "Uruguai" }
      ]
    }
  },  
  mounted: function () {
  this.timer = setInterval(() => {
    let list ="";
      let flag ="";
      for(let i=1; i<=31; i++) {
        var selected = document.querySelectorAll('.selected'+i);
        selected.forEach(select => {
          if(select.id == "team1"){flag = "🇶🇦";} 
          else if(select.id == "team2"){flag = "🇪🇨";}
          else if(select.id == "team3"){flag = "🇳🇱";}
          else if(select.id == "team4"){flag = "🇸🇳";}
          else if(select.id == "team5"){flag = "🇺🇸";}
          else if(select.id == "team6"){flag = "🏴󠁧󠁢󠁥󠁮󠁧󠁿";}
          else if(select.id == "team7"){flag = "🇮🇷";}
          else if(select.id == "team8"){flag = "🏴󠁧󠁢󠁷󠁬󠁳󠁿";}
          else if(select.id == "team9"){flag = "🇸🇦";}
          else if(select.id == "team10"){flag = "🇦🇷";}
          else if(select.id == "team11"){flag = "🇲🇽";}
          else if(select.id == "team12"){flag = "🇵🇱";}
          else if(select.id == "team13"){flag = "🇩🇰";}
          else if(select.id == "team14"){flag = "🇦🇺";}
          else if(select.id == "team15"){flag = "🇫🇷";}
          else if(select.id == "team16"){flag = "🇹🇳";}
          else if(select.id == "team17"){flag = "🇩🇪";}
          else if(select.id == "team18"){flag = "🇨🇷";}
          else if(select.id == "team19"){flag = "🇪🇸";}
          else if(select.id == "team20"){flag = "🇯🇵";}
          else if(select.id == "team21"){flag = "🇧🇪";}
          else if(select.id == "team22"){flag = "🇨🇦";}
          else if(select.id == "team23"){flag = "🇭🇷";}
          else if(select.id == "team24"){flag = "🇲🇦";}
          else if(select.id == "team25"){flag = "🇧🇷";}
          else if(select.id == "team26"){flag = "🇨🇲";}
          else if(select.id == "team27"){flag = "🇷🇸";}
          else if(select.id == "team28"){flag = "🇨🇭";}
          else if(select.id == "team29"){flag = "🇰🇷";}
          else if(select.id == "team30"){flag = "🇬🇭";}
          else if(select.id == "team31"){flag = "🇵🇹";}
          else if(select.id == "team32"){flag = "🇺🇾";}
          else {flag = "";}
          list += flag + ",";
        })
      }
      var flags = list.split(',');

      var shareInfo = "Simulador Mundial 2022\n\nOctavos \n" + flags[0] + 'x' + flags[1] + ' | ' + flags[2] + 'x' + flags[3] + ' | ' + flags[4] + 'x' + flags[5] + ' | ' + flags[6] + 'x' + flags[7] + '\n' 
      + flags[8] + 'x' + flags[9] + ' | ' + flags[10] + 'x' + flags[11] + ' | ' + flags[12] + 'x' + flags[13] + ' | ' + flags[14] + 'x' + flags[15] +
      "\n\n Cuartos \n" + flags[16] + 'x' + flags[17] + ' | ' + flags[18] + 'x' + flags[19] + '\n'
      + flags[20] + 'x' + flags[21] + ' | ' + flags[22] + 'x' + flags[23] +
      "\n\n Semifinal \n" + flags[24] + 'x' + flags[25] + '\n'
      + flags[26] + 'x' + flags[27] +
      "\n\n Final \n" + flags[28] + 'x' + flags[29] + '\n'
      +"\n Campeón \n" + flags[30] + '\n\n' + "¿Cuál es tu campeón? Prueba nuestro simulador";
      this.title=shareInfo; 
    
  }, 1000)
},
  methods:{
    checkTac(){
      var tac = document.getElementById('tac');
      if(tac.checked == true) {
        const btnPrint = document.getElementById('btnPrint');
        btnPrint.classList.add("active");
        const btnShare = document.getElementById('btnShareMobile');
        btnShare.classList.add("active");   
   
      } else {
        const btnPrint = document.getElementById('btnPrint');
        btnPrint.classList.remove("active");
        const btnShare = document.getElementById('btnShareMobile');
        btnShare.classList.remove("active");

      }     
    },
    changeTwitter(){
      let list ="";
      let flag ="";
      for(let i=1; i<=31; i++) {
        var selected = document.querySelectorAll('.selected'+i);
        selected.forEach(select => {
          if(select.id == "team1"){flag = "🇶🇦";} 
          else if(select.id == "team2"){flag = "🇪🇨";}
          else if(select.id == "team3"){flag = "🇳🇱";}
          else if(select.id == "team4"){flag = "🇸🇳";}
          else if(select.id == "team5"){flag = "🇺🇸";}
          else if(select.id == "team6"){flag = "🏴󠁧󠁢󠁥󠁮󠁧󠁿";}
          else if(select.id == "team7"){flag = "🇮🇷";}
          else if(select.id == "team8"){flag = "🏴󠁧󠁢󠁷󠁬󠁳󠁿";}
          else if(select.id == "team9"){flag = "🇸🇦";}
          else if(select.id == "team10"){flag = "🇦🇷";}
          else if(select.id == "team11"){flag = "🇲🇽";}
          else if(select.id == "team12"){flag = "🇵🇱";}
          else if(select.id == "team13"){flag = "🇩🇰";}
          else if(select.id == "team14"){flag = "🇦🇺";}
          else if(select.id == "team15"){flag = "🇫🇷";}
          else if(select.id == "team16"){flag = "🇹🇳";}
          else if(select.id == "team17"){flag = "🇩🇪";}
          else if(select.id == "team18"){flag = "🇨🇷";}
          else if(select.id == "team19"){flag = "🇪🇸";}
          else if(select.id == "team20"){flag = "🇯🇵";}
          else if(select.id == "team21"){flag = "🇧🇪";}
          else if(select.id == "team22"){flag = "🇨🇦";}
          else if(select.id == "team23"){flag = "🇭🇷";}
          else if(select.id == "team24"){flag = "🇲🇦";}
          else if(select.id == "team25"){flag = "🇧🇷";}
          else if(select.id == "team26"){flag = "🇨🇲";}
          else if(select.id == "team27"){flag = "🇷🇸";}
          else if(select.id == "team28"){flag = "🇨🇭";}
          else if(select.id == "team29"){flag = "🇰🇷";}
          else if(select.id == "team30"){flag = "🇬🇭";}
          else if(select.id == "team31"){flag = "🇵🇹";}
          else if(select.id == "team32"){flag = "🇺🇾";}
          else {flag = "";}
          list += flag + ",";
        })
      }
      var flags = list.split(',');

      var shareInfo = "Simulador Mundial 2022\n\nOctavos \n" + flags[0] + 'x' + flags[1] + ' | ' + flags[2] + 'x' + flags[3] + ' | ' + flags[4] + 'x' + flags[5] + ' | ' + flags[6] + 'x' + flags[7] + '\n' 
      + flags[8] + 'x' + flags[9] + ' | ' + flags[10] + 'x' + flags[11] + ' | ' + flags[12] + 'x' + flags[13] + ' | ' + flags[14] + 'x' + flags[15] +
      "\n\n Cuartos \n" + flags[16] + 'x' + flags[17] + ' | ' + flags[18] + 'x' + flags[19] + '\n'
      + flags[20] + 'x' + flags[21] + ' | ' + flags[22] + 'x' + flags[23] +
      "\n\n Semifinal \n" + flags[24] + 'x' + flags[25] + '\n'
      + flags[26] + 'x' + flags[27] +
      "\n\n Final \n" + flags[28] + 'x' + flags[29] + '\n'
      +"\n Campeón \n" + flags[30] + '\n\n' + "¿Cuál es tu campeón? Prueba nuestro simulador";
      this.title=shareInfo;     
    },
    printMobile() {
      const print = document.getElementById('printArea');
      print.classList.add("bgPrintMobile");
      var node = document.getElementById('printArea');      
      htmlToImage.toPng(node)
      .then(function (dataUrl) {
    download(dataUrl, 'bwin_predictor_world_cup.png');
    print.classList.remove("bgPrintMobile");
      })
      .catch(function (error) {
        console.error('oops, something went wrong!', error);
      });       
    },
    printThis() {
      const print = document.getElementById('printArea');
      print.classList.add("bgPrint");
      var node = document.getElementById('printArea');
      
      htmlToImage.toPng(node)
      .then(function (dataUrl) {
        const btnShare = document.getElementById('btnShare');
    btnShare.click();   
    download(dataUrl, 'bwin_predictor_world_cup.png');
    print.classList.remove("bgPrint");
      })
      .catch(function (error) {
        console.error('oops, something went wrong!', error);
      });  
      
    },
    ClearAll(){
      const finals = document.querySelectorAll('.emptyTeam');
      finals.forEach(final => {
      final.id="team";

    });
    const radios = document.querySelectorAll('.form-check-input');
    radios.forEach(radio => {
      radio.checked = false;
    });
    const lines = document.querySelectorAll('.actived');
    lines.forEach(line => {
      line.classList.remove("actived");
    });
    const btnPrint = document.getElementById('btnPrint');
    btnPrint.classList.remove("active");
    const btnShare = document.getElementById('btnShareMobile');
    btnShare.classList.remove("active");
    var tac = document.getElementById('tac');
    tac.checked = false;
    tac.disabled = true;
    const check = document.getElementById('checkmark');
        check.classList.remove("active");
    this.placeA1='',
    this.placeA2='',
    this.placeB1='',
    this.placeB2='',
    this.placeC1='',
    this.placeC2='',
    this.placeD1='',
    this.placeD2='',
    this.placeE1='',
    this.placeE2='',
    this.placeF1='',
    this.placeF2='',
    this.placeG1='',
    this.placeG2='',
    this.placeH1='',
    this.placeH2='',
    this.quarter1='',
    this.quarter2='',
    this.quarter3='',
    this.quarter4='',
    this.quarter5='',
    this.quarter6='',
    this.quarter7='',
    this.quarter8='',
    this.semi1='',
    this.semi2='',
    this.semi3='',
    this.semi4='',
    this.final1='',
    this.final2='',
    this.winner=''
    },
    Clearfirsts(id){
      const firsts = document.querySelectorAll('.finals');
      firsts.forEach(first => {
        first.id="team";
      });
      const first = document.getElementById('team'+id);
      if (first){ 
        first.id="team";      
      }
      const lines = document.querySelectorAll('.actived');
      lines.forEach(line => {
        line.classList.remove("actived");
      });
      const btnPrint = document.getElementById('btnPrint');
      btnPrint.classList.remove("active");
      const btnShare = document.getElementById('btnShareMobile');
      btnShare.classList.remove("active");
      var tac = document.getElementById('tac');
      tac.checked = false;
      tac.disabled = true;
      const check = document.getElementById('checkmark');
        check.classList.remove("active");
      this.quarter1='',
      this.quarter2='',
      this.quarter3='',
      this.quarter4='',
      this.quarter5='',
      this.quarter6='',
      this.quarter7='',
      this.quarter8='',
      this.semi1='',
      this.semi2='',
      this.semi3='',
      this.semi4='',
      this.final1='',
      this.final2='',
      this.winner=''
    },
    selectFirsts(id, n, m, o, p){
      const selectFirsts = document.querySelectorAll('.select'+n);
      selectFirsts.forEach(selectFirst => {
        if(selectFirst.id !="team" ) {
          selectFirst.id ="team"+id;
          const selectSeconds = document.querySelectorAll('.select'+m);
          selectSeconds.forEach(selectSecond => {
            if(selectSecond.id !="team") {
              selectSecond.id ="team"+id;
              const selectThirds = document.querySelectorAll('.select'+o);
              selectThirds.forEach(selectThird => {
            if(selectThird.id !="team") {
              selectThird.id ="team"+id;
              const selectfourths = document.querySelectorAll('.select'+p);
              selectfourths.forEach(selectfourth => {
            if(selectfourth.id !="team") {
              selectfourth.id ="team"+id;
              
            }
          });
            } 
          });
            } 
          });  
        } 
        const classes1 = document.querySelectorAll('.winner'+m);
        classes1.forEach(classe1 => {
        classe1.classList.remove("actived");
        if(classe1.id == "team"+id) {
          classe1.classList.add("actived");
            } 
      });
      const classes2 = document.querySelectorAll('.winner'+o);
        classes2.forEach(classe2 => {
        classe2.classList.remove("actived");
        if(classe2.id == "team"+id) {
          classe2.classList.add("actived");
            } 
      });
      const classes3 = document.querySelectorAll('.winner'+p);
        classes3.forEach(classe3 => {
        classe3.classList.remove("actived");
        if(classe3.id == "team"+id) {
          classe3.classList.add("actived");
            } 
      });
      });  
    },
    selectSeconds(id, m, o, p){
          const selectSeconds = document.querySelectorAll('.select'+m);
          selectSeconds.forEach(selectSecond => {
            if(selectSecond.id !="team") {
              selectSecond.id ="team"+id;
              const selectThirds = document.querySelectorAll('.select'+o);
              selectThirds.forEach(selectThird => {
            if(selectThird.id !="team") {
              selectThird.id ="team"+id;
              const selectfourths = document.querySelectorAll('.select'+p);
              selectfourths.forEach(selectfourth => {
            if(selectfourth.id !="team") {
              selectfourth.id ="team"+id;
            } 
          });
            } 
          });
            } 
      const classes2 = document.querySelectorAll('.winner'+o);
        classes2.forEach(classe2 => {
        classe2.classList.remove("actived");
        if(classe2.id == "team"+id) {
          classe2.classList.add("actived");
            } 
      });
      const classes3 = document.querySelectorAll('.winner'+p);
        classes3.forEach(classe3 => {
        classe3.classList.remove("actived");
        if(classe3.id == "team"+id) {
          classe3.classList.add("actived");
            } 
      });
      });      
    },
    selectThirds(id, o, p){
              const selectThirds = document.querySelectorAll('.select'+o);
              selectThirds.forEach(selectThird => {
            if(selectThird.id !="team") {
              selectThird.id ="team"+id;
              const selectfourths = document.querySelectorAll('.select'+p);
              selectfourths.forEach(selectfourth => {
            if(selectfourth.id !="team") {
              selectfourth.id ="team"+id;
            }
          });
            } 
      const classes3 = document.querySelectorAll('.winner'+p);
        classes3.forEach(classe3 => {
        classe3.classList.remove("actived");
        if(classe3.id == "team"+id) {
          classe3.classList.add("actived");
            } 
      });
          });           
    },
    selectFourths(id, p){
              const selectfourths = document.querySelectorAll('.select'+p);
              selectfourths.forEach(selectfourth => {
            if(selectfourth.id !="team") {
              selectfourth.id ="team"+id;        
            } 
          })
          var tac = document.getElementById('tac');
    tac.disabled = false;
    const check = document.getElementById('checkmark');
        check.classList.add("active");
    },
    selectLine(cl, idt) {
      const classes = document.querySelectorAll('.winner'+cl);
      classes.forEach(classe => {
        classe.classList.remove("actived");
        if(classe.id == "team"+idt) {
          classe.classList.add("actived");
            } 
      });
    },

    
    ChangeA1(place1){      
      if (this.placeA2 == place1) {
        this.placeA2 = '';
      }
      this.placeA1=place1;
    },
    ChangeA2(place2){
      
      if (this.placeA1 == place2) {
        this.placeA1 = '';
      }
      this.placeA2=place2;
    },
    ChangeB1(place1){
      if (this.placeB2 == place1) {
        this.placeB2 = '';
      }
      this.placeB1=place1;
    },
    ChangeB2(place2){
      if (this.placeB1 == place2) {
        this.placeB1 = '';
      }
      this.placeB2=place2;
    },
    ChangeC1(place1){
      if (this.placeC2 == place1) {
        this.placeC2 = '';
      }
      this.placeC1=place1;
    },
    ChangeC2(place2){
      if (this.placeC1 == place2) {
        this.placeC1 = '';
      }
      this.placeC2=place2;
    },
    ChangeD1(place1){
      if (this.placeD2 == place1) {
        this.placeD2 = '';
      }
      this.placeD1=place1;
    },
    ChangeD2(place2){
      if (this.placeD1 == place2) {
        this.placeD1 = '';
      }
      this.placeD2=place2;
    },
    ChangeE1(place1){
      if (this.placeE2 == place1) {
        this.placeE2 = '';
      }
      this.placeE1=place1;
    },
    ChangeE2(place2){
      if (this.placeE1 == place2) {
        this.placeE1 = '';
      }
      this.placeE2=place2;
    },
    ChangeF1(place1){
      if (this.placeF2 == place1) {
        this.placeF2 = '';
      }
      this.placeF1=place1;
    },
    ChangeF2(place2){
      if (this.placeF1 == place2) {
        this.placeF1 = '';
      }
      this.placeF2=place2;
    },
    ChangeG1(place1){
      if (this.placeG2 == place1) {
        this.placeG2 = '';
      }
      this.placeG1=place1;
    },
    ChangeG2(place2){
      if (this.placeG1 == place2) {
        this.placeG1 = '';
      }
      this.placeG2=place2;
    },
    ChangeH1(place1){
      if (this.placeH2 == place1) {
        this.placeH2 = '';
      }
      this.placeH1=place1;
    },
    ChangeH2(place2){
      if (this.placeH1 == place2) {
        this.placeH1 = '';
      }
      this.placeH2=place2;
    },
    selectQuarter1(quarter){this.quarter1=quarter;},
    selectQuarter2(quarter){this.quarter2=quarter;},
    selectQuarter3(quarter){this.quarter3=quarter;},
    selectQuarter4(quarter){this.quarter4=quarter;},
    selectQuarter5(quarter){this.quarter5=quarter;},
    selectQuarter6(quarter){this.quarter6=quarter;},
    selectQuarter7(quarter){this.quarter7=quarter;},
    selectQuarter8(quarter){this.quarter8=quarter;},
    selectSemi1(semi){this.semi1=semi;},
    selectSemi2(semi){this.semi2=semi;},
    selectSemi3(semi){this.semi3=semi;},
    selectSemi4(semi){this.semi4=semi;},
    selectFinal1(final){this.final1=final;},
    selectFinal2(final){this.final2=final;},
    selectWinner(winner){this.winner=winner;}
}

}
</script>

<style scope>
  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700&display=swap');
  * {
    font-family:'Roboto', sans-serif;
  }
  html, body {
    background-color: transparent;
  }
  .carousel-inner > .item > a > img, .carousel-inner > .item > img, .img-responsive, .thumbnail a > img, .thumbnail > img {
  display: block;
  max-width: 100%;
  height: auto
}
.carousel {
  position: relative
}
.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden
}
.carousel-inner > .item {
  position: relative;
  display: none;
  -webkit-transition: .6s ease-in-out left;
  -o-transition: .6s ease-in-out left;
  transition: .6s ease-in-out left
}
.carousel-inner > .item > a > img, .carousel-inner > .item > img {
  line-height: 1
}
.carousel-control {
  display: none;
}
#tac {
  background-color: #FC0;
  border: none;
}
.tacLink {
  color: #FC0;
  text-decoration: none;
}
.tacLink:hover {
  color: #FFF;
}
.checkTac {
  width: max-content;
  position: relative;
  margin: 0px auto;
}
.container.small {
  padding-left: 20px !important;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: .875em;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  max-width: max-content !important;
    padding: 0;
    margin: 0;
}
/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 3px;
  left: 0px;
  height: 15px;
  width: 15px;
  background-color: #444;
  border-radius: 3px;
  cursor: initial;
}
.checkmark.active {
  background-color: #fff;
  cursor: pointer;
}



/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #fc0;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 5px;
  top: 3px;
  width: 6px;
  height: 8px;
  border: solid #000;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

@media all and (transform-3d), (-webkit-transform-3d) {
  .carousel-inner > .item {
    -webkit-transition: -webkit-transform .6s ease-in-out;
    -o-transition: -o-transform .6s ease-in-out;
    transition: -webkit-transform .6s ease-in-out;
    transition: transform .6s ease-in-out;
    transition: transform .6s ease-in-out, -webkit-transform .6s ease-in-out, -o-transform .6s ease-in-out;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-perspective: 1000px;
    perspective: 1000px
  }
  .carousel-inner > .item.active.right, .carousel-inner > .item.next {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
    left: 0
  }
  .carousel-inner > .item.active.left, .carousel-inner > .item.prev {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
    left: 0
  }
  .carousel-inner > .item.active, .carousel-inner > .item.next.left, .carousel-inner > .item.prev.right {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    left: 0
  }
}
.carousel-inner > .active, .carousel-inner > .next, .carousel-inner > .prev {
  display: block
}
.carousel-inner > .active {
  left: 0
}
.carousel-inner > .next, .carousel-inner > .prev {
  position: absolute;
  top: 0;
  width: 100%
}
.carousel-inner > .next {
  left: 100%
}
.carousel-inner > .prev {
  left: -100%
}
.carousel-inner > .next.left, .carousel-inner > .prev.right {
  left: 0
}
.carousel-inner > .active.left {
  left: -100%
}
.carousel-inner > .active.right {
  left: 100%
}




  h1{
    font-size: 25px !important;
    color:#FFF;
    font-family:'Roboto', sans-serif;
    font-weight: 700 !important;
  }
  h3{
    font-size: 16px !important;
    color:#FC0;
    font-family:'Roboto', sans-serif;
    font-weight: 300 !important;
  }
  #printArea {    
    padding: 20px 40px;
  }
  .bgPrintMobile {
    background-image: url('~@/assets/bgPrint.jpg');
    background-position: top center;
    transform: scale(1) !important;
    margin-bottom: auto !important;
    margin-left: 0 !important;
    overflow: auto;
  }
  .bgPrint {
    background-image: url('~@/assets/bgPrint.jpg');
    background-position: top center;
  }
  .groupMobile {
    display: none;
  }
.row {
    margin-bottom: 1px;
}
.row.listTeam:last-child {
    margin-bottom: 0px;
    border-radius: 0px 0px 10px 10px;
}
.col.align-self-center {
    padding-left: 0px;
    padding-right: 0px;
}
.col.groupList:hover {
    box-shadow: 0px 0px 20px 0px #ffffff33;
}
.emptyCell {
  height: 30px;
}
.btnPrint { text-decoration: none; opacity: 0.3; background-color: #fff; color:#000; border:none; border-radius: 3px; font-weight: bold; padding:5px 15px !important; margin: 20px; pointer-events: none; cursor: not-allowed; }
.btnPrint.active { opacity: 1; background-color: #FC0; pointer-events: initial; cursor: pointer; }
.btnShare {display: none;}
.btnClear {background-color: #f6f6f6; color:#000; border:none; border-radius: 3px; font-weight: bold; padding:5px 15px; margin: 20px;}
.rightDown {
    background-image: url('~@/assets/rightDownEmpty.svg');
    background-position: right bottom;
    background-repeat: no-repeat;
    display: flex;
    background-size: 45px;
  }
  .rightUp {
    background-image: url('~@/assets/rightUpEmpty.svg');
    background-position: right top;
    background-repeat: no-repeat;
    display: flex;
    background-size: 45px;
  }
  .leftDown {
    background-image: url('~@/assets/leftDownEmpty.svg');
    background-position: left bottom;
    background-repeat: no-repeat;
    display: flex;
    background-size: 45px;
  }
  .leftUp {
    background-image: url('~@/assets/leftUpEmpty.svg');
    background-position: left top;
    background-repeat: no-repeat;
    display: flex;
    background-size: 45px;
  }
  .rightUpQuarter {
    background-image: url('~@/assets/rightUpQuarterEmpty.svg');
    background-position: right top;
    background-repeat: no-repeat;
    display: flex;
    background-size: 110px;
  }
  .rightDownQuarter {
    background-image: url('~@/assets/rightDownQuarterEmpty.svg');
    background-position: right bottom;
    background-repeat: no-repeat;
    display: flex;
    background-size: 110px;
  }
  .leftUpQuarter {
    background-image: url('~@/assets/leftUpQuarterEmpty.svg');
    background-position: left top;
    background-repeat: no-repeat;
    display: flex;
    background-size: 110px;
  }
  .leftDownQuarter {
    background-image: url('~@/assets/leftDownQuarterEmpty.svg');
    background-position: left bottom;
    background-repeat: no-repeat;
    display: flex;
    background-size: 110px;
  }
  .rightUpSemi {
    background-image: url('~@/assets/rightUpSemiEmpty.svg');
    background-position: right top;
    background-repeat: no-repeat;
    display: flex;
    background-size: 110px;
  }
  .rightDownSemi {
    background-image: url('~@/assets/rightDownSemiEmpty.svg');
    background-position: right bottom;
    background-repeat: no-repeat;
    display: flex;
    background-size: 110px;
  }
  .leftUpSemi {
    background-image: url('~@/assets/leftUpSemiEmpty.svg');
    background-position: left top;
    background-repeat: no-repeat;
    display: flex;
    background-size: 110px;
  }
  .leftDownSemi {
    background-image: url('~@/assets/leftDownSemiEmpty.svg');
    background-position: left bottom;
    background-repeat: no-repeat;
    display: flex;
    background-size: 110px;
  }
  .centerFinal {
    background-image: url('~@/assets/centerFinalEmpty.svg');
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    background-size: 110px;
  }
  .rightDown:has(.actived) {
    background-image: url('~@/assets/rightDown.svg');
  }
  .rightUp:has(.actived) {
    background-image: url('~@/assets/rightUp.svg');
  }
  .leftDown:has(.actived) {
    background-image: url('~@/assets/leftDown.svg');
  }
  .leftUp:has(.actived) {
    background-image: url('~@/assets/leftUp.svg');
  }
  .rightDownQuarter:has(.actived) {
    background-image: url('~@/assets/rightDownQuarter.svg');
  }
  .rightUpQuarter:has(.actived) {
    background-image: url('~@/assets/rightUpQuarter.svg');
  }
  .leftDownQuarter:has(.actived) {
    background-image: url('~@/assets/leftDownQuarter.svg');
  }
  .leftUpQuarter:has(.actived) {
    background-image: url('~@/assets/leftUpQuarter.svg');
  }
  .rightDownSemi:has(.actived) {
    background-image: url('~@/assets/rightDownSemi.svg');
  }
  .rightUpSemi:has(.actived) {
    background-image: url('~@/assets/rightUpSemi.svg');
  }
  .leftDownSemi:has(.actived) {
    background-image: url('~@/assets/leftDownSemi.svg');
  }
  .leftUpSemi:has(.actived) {
    background-image: url('~@/assets/leftUpSemi.svg');
  }
  .centerFinal:has(.actived) {
    background-image: url('~@/assets/centerFinal.svg');
  }  
  .disable {
    pointer-events: none; cursor: not-allowed;
  }
.emptyTeam {
  height: 50px;
  width: 50px;
  border-radius: 100%;
  border: 3px dotted #fff;
  background-position: center;
  background-size: 0px;
  background-color: #000;
  margin: 20px auto;
  transition: all 0.3s ease;
}
.nameLeft::before {
    content: "";
    position: relative;
    left: -53px;
    top: 10px;
    background-color: #000;
}
.nameRight::before {
    content: "";
    position: relative;
    right: -53px;
    top: 10px;
    background-color: #000;
}
.semi.nameLeft::before {
    left: -60px;
    top: 20px;
}
.semi.nameRight::before {
    right: -60px;
    top: 20px;
}
.quarter {
    margin: 65px auto;
}
.semi {
    height: 70px;
    width: 70px;
    background-size: 100px !important;
    margin: 145px auto;
}
.champion {
  height: 110px !important;
  width: 110px !important;
  background-image:url('~@/assets/champ.svg');
  background-size: 165px !important;
    background-repeat: no-repeat;
    color: transparent;
}

.champion::before {
  content: "";
    position: relative;
    left: 8px;
    color: #FFF;
    top: 110px;
}

.emptyTeam:hover {
  background-size: 100px !important;
    box-shadow: 0px 0px 0px 5px #fc0;
}
.champion:hover {  
  background-size: 155px !important;
}
#team1 {
  background-image:url('~@/assets/flags/Catar.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
content: "QAT";
}
#team1::before {
    content: "QAT";
}
#team2 {
  background-image:url('~@/assets/flags/Equador.svg'); 
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team2::before {
    content: "ECU";
}
#team3 {
  background-image:url('~@/assets/flags/Holanda.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team3::before {
    content: "HOL";
}
#team4 {
  background-image:url('~@/assets/flags/Senegal.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team4::before {
    content: "SEN";
}
#team5 {
  background-image:url('~@/assets/flags/Estados_Unidos.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team5::before {
    content: "USA";
}
#team6 {
  background-image:url('~@/assets/flags/Inglaterra.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team6::before {
    content: "ING";
}
#team7 {
  background-image:url('~@/assets/flags/Ira.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team7::before {
    content: "IRA";
}
#team8 {
  background-image:url('~@/assets/flags/Pais_de_Gales.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team8::before {
    content: "GAL";
}
#team9 {
  background-image:url('~@/assets/flags/Arabia_Saudita.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team9::before {
    content: "ARA";
}
#team10 {
  background-image:url('~@/assets/flags/Argentina.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team10::before {
    content: "ARG";
}
#team11 {
  background-image:url('~@/assets/flags/Mexico.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team11::before {
    content: "MEX";
}
#team12 {
  background-image:url('~@/assets/flags/Polonia.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team12::before {
    content: "POL";
}
#team13 {
  background-image:url('~@/assets/flags/Dinamarca.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team13::before {
    content: "DIN";
}
#team14 {
  background-image:url('~@/assets/flags/Australia.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team14::before {
    content: "AUS";
}
#team15 {
  background-image:url('~@/assets/flags/Franca.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team15::before {
    content: "FRA";
}
#team16 {
  background-image:url('~@/assets/flags/Tunisia.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team16::before {
    content: "TUN";
}
#team17 {
  background-image:url('~@/assets/flags/Alemanha.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team17::before {
    content: "ALE";
}
#team18 {
  background-image:url('~@/assets/flags/Costa_Rica.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team18::before {
    content: "COS";
}
#team19 {
  background-image:url('~@/assets/flags/Espanha.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team19::before {
    content: "ESP";
}
#team20 {
  background-image:url('~@/assets/flags/Japao.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team20::before {
    content: "JAP";
}
#team21 {
  background-image:url('~@/assets/flags/Belgica.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team21::before {
    content: "BEL";
}
#team22 {
  background-image:url('~@/assets/flags/Canada.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team22::before {
    content: "CAN";
}
#team23 {
  background-image:url('~@/assets/flags/Croacia.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team23::before {
    content: "CRO";
}
#team24 {
  background-image:url('~@/assets/flags/Marrocos.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team24::before {
    content: "MAR";
}
#team25 {
  background-image:url('~@/assets/flags/Brasil.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team25::before {
    content: "BRA";
}
#team26 {
  background-image:url('~@/assets/flags/Camaroes.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team26::before {
    content: "CAM";
}
#team27 {
  background-image:url('~@/assets/flags/Servia.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team27::before {
    content: "SER";
}
#team28 {
  background-image:url('~@/assets/flags/Suica.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team28::before {
    content: "SUI";
}
#team29 {
  background-image:url('~@/assets/flags/Coreia_do_Sul.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team29::before {
    content: "COR";
}
#team30 {
  background-image:url('~@/assets/flags/Gana.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team30::before {
    content: "GAN";
}
#team31 {
  background-image:url('~@/assets/flags/Portugal.svg');
background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team31::before {
    content: "POR";
}
#team32 {
  background-image:url('~@/assets/flags/Uruguai.svg');
  background-size: 70px;
border: 3px solid #FFF;
cursor: pointer;
pointer-events: initial;
}
#team32::before {
    content: "URU";
}
.active {
  background-color: transparent;
}
.carousel-indicators {
  position: initial !important;
  margin-bottom: 20px !important;
}
.carousel-indicators li{
  padding: 8px 15px;
  cursor: pointer;
  border-radius: 50%;
}
.carousel-indicators .active {
  background-color: #ffffff2e;
}
.carousel-item {
  transition: transform .3s ease-in-out
}
.carousel-inner > .item > img,
  .carousel-inner > .item > a > img {
    width: 70%;
    margin: auto;
  }
  
@media only screen and (max-width: 1000px) {
  .groupDesktop {
    display: none;
  }
  .groupMobile {
    display: initial;
  }
  .row.rowMobile {
    width: 1971px;
}
.groupList {
  margin: 0;
}
}
@media only screen and (max-width: 700px) {
  .groupDesktop {
    display: none;
  }
  .groupMobile {
    display: initial;
  }
  .row.rowMobile {
    width: 1971px;
}
#printArea {
  transform: scale(0.5);
    transform-origin: top;
    width: 200% !important;
    margin-left: -50%;
    height: 800px;
    margin-bottom: calc((0.5 - 1) * 800px);
}
.groupList {
  margin: 0 5px;
}
.semi {
    height: 50px;
    width: 50px;
    background-size: 70px !important;
    margin: 155px auto;
  }
  .champion {
    height: 90px !important;
    width: 90px !important;
    background-size: 135px !important;
  }
  #btnPrint {
    display: none;
  }
  #btnShareMobile { display: initial; text-decoration: none; opacity: 0.3; background-color: #fff; color:#000; border:none; border-radius: 3px; font-weight: bold; padding:5px 15px !important; margin: 20px; pointer-events: none; cursor: not-allowed; }
  #btnShareMobile.active { opacity: 1; background-color: #FC0; pointer-events: initial; cursor: pointer; }
  .checkTac {
  max-width: 90%;
}
}

</style>